var map = {
	"./affix/style/index.tsx": 981,
	"./alert/style/index.tsx": 983,
	"./anchor/style/index.tsx": 985,
	"./auto-complete/style/index.tsx": 987,
	"./avatar/style/index.tsx": 992,
	"./back-top/style/index.tsx": 994,
	"./badge/style/index.tsx": 996,
	"./breadcrumb/style/index.tsx": 998,
	"./button/style/index.tsx": 190,
	"./calendar/style/index.tsx": 1000,
	"./card/style/index.tsx": 1003,
	"./carousel/style/index.tsx": 1006,
	"./cascader/style/index.tsx": 1008,
	"./checkbox/style/index.tsx": 193,
	"./col/style/index.tsx": 1011,
	"./collapse/style/index.tsx": 1012,
	"./date-picker/style/index.tsx": 1014,
	"./divider/style/index.tsx": 1017,
	"./dropdown/style/index.tsx": 906,
	"./form/style/index.tsx": 1020,
	"./grid/style/index.tsx": 362,
	"./icon/style/index.tsx": 1022,
	"./input-number/style/index.tsx": 1023,
	"./input/style/index.tsx": 112,
	"./layout/style/index.tsx": 1025,
	"./list/style/index.tsx": 1027,
	"./locale-provider/style/index.tsx": 1031,
	"./mention/style/index.tsx": 1033,
	"./menu/style/index.tsx": 1035,
	"./message/style/index.tsx": 1038,
	"./modal/style/index.tsx": 1040,
	"./notification/style/index.tsx": 1042,
	"./pagination/style/index.tsx": 364,
	"./popconfirm/style/index.tsx": 1044,
	"./popover/style/index.tsx": 907,
	"./progress/style/index.tsx": 908,
	"./radio/style/index.tsx": 360,
	"./rate/style/index.tsx": 1047,
	"./row/style/index.tsx": 1049,
	"./select/style/index.tsx": 192,
	"./slider/style/index.tsx": 1050,
	"./spin/style/index.tsx": 363,
	"./steps/style/index.tsx": 1052,
	"./switch/style/index.tsx": 1054,
	"./table/style/index.tsx": 1056,
	"./tabs/style/index.tsx": 904,
	"./tag/style/index.tsx": 1058,
	"./time-picker/style/index.tsx": 905,
	"./timeline/style/index.tsx": 1060,
	"./tooltip/style/index.tsx": 358,
	"./transfer/style/index.tsx": 1062,
	"./tree-select/style/index.tsx": 1064,
	"./tree/style/index.tsx": 1066,
	"./upload/style/index.tsx": 1068,
	"./version/style/index.tsx": 1070
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 980
// module chunks = 1